import React, { useState } from 'react';
import "./WarningViewComponent.css";

interface AlertIconProps {
    size: string;
}

export enum WarningColor {
    WarningRed = "warning_red",
    WarningOrange = "warning_orange",
    WarningYellow = "warning_yellow",
}

const AlertIcon: React.FC<AlertIconProps> = ({ size }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
);

interface WarningViewProps {
    title: string;
    color: WarningColor;
    hazards: WarningData[];
}

export interface WarningData {
    title: string;
    items: string[]
}

const WarningViewComponent = (props: WarningViewProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    let textColorClass: string = ""
    switch (props.color) {
        case WarningColor.WarningRed:
            textColorClass = "hazard-text-color-red"
            break;
        case WarningColor.WarningOrange:
            textColorClass = "hazard-text-color-orange"
            break;
        case WarningColor.WarningYellow:
            textColorClass = "hazard-text-color-yellow";
            break;
    }

    return (
        <div className={`hazard-section`}>
            <div className={`alert-box alert-box-enhanced cursor-pointer ${textColorClass}`}>
                <div
                    className={`alert-header`}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className={`alert-dot ${props.color === WarningColor.WarningRed ? 'alert-dot-red' : (props.color === WarningColor.WarningOrange? 'alert-dot-orange' : 'alert-dot-yellow')}`}/>
                    <AlertIcon size="28"/>
                    <h4 className={`alert-title ${textColorClass}`}>{props.title}</h4>
                    <svg
                        className={`ml-auto transform transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path d="M6 9l6 6 6-6"/>
                    </svg>
                </div>

                {isExpanded && (
                    <div className="alert-content" style={{cursor: 'pointer'}}>
                        {props.hazards.map((hazard, index) => (
                            <div key={index} className="enhanced-hazard-item hazard-item">
                                <AlertIcon size="18"/>
                                <div>
                                    <span className={`hazard-text`}>{hazard.title}</span>
                                    <br/>
                                    <span className={`hazard-location`}>
                                        {hazard.items.map((item, index) => (
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                            <React.Fragment key={index}>
                                                {item}
                                            </React.Fragment>
                                            </div>
                                        ))}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WarningViewComponent;